(function () {
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    var data = detail.data || {};
    if (data.source !== 'product-form-component') return;
    if (data.didError) return;
    window.location.href = '/cart';
  });
})();
